import apiClient from './apiClient';

export interface ESocialReferenceItem {
  id: number;
  tableNumber: number;
  code: string;
  description: string;
  parentCode?: string;
}

class ESocialReferenceService {
  async search(tableNumber: number, query: string, limit = 20): Promise<ESocialReferenceItem[]> {
    const response = await apiClient.get(
      `/esocial-reference/${tableNumber}/search?q=${encodeURIComponent(query)}&limit=${limit}`
    );
    return response.data?.data ?? response.data;
  }

  async lookup(tableNumber: number, codes: string[]): Promise<ESocialReferenceItem[]> {
    const response = await apiClient.get(
      `/esocial-reference/${tableNumber}/lookup?codes=${codes.join(',')}`
    );
    return response.data?.data ?? response.data;
  }

  async listAll(tableNumber: number): Promise<ESocialReferenceItem[]> {
    const response = await apiClient.get(`/esocial-reference/${tableNumber}`);
    return response.data?.data ?? response.data;
  }
}

export const esocialReferenceService = new ESocialReferenceService();
